import { MsInSecond } from '@shared/constants/times/ms-in-second'

export const MsInMinute: number = 60 * MsInSecond
